//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import type { ToneColor } from "../types";
import { toneOf } from "./tone";

export interface MapPinProps extends HTMLAttributes<HTMLSpanElement> {
  color?: ToneColor;
  variant?: "default" | "label" | "dot";
  label?: ReactNode;
  children?: ReactNode;
  size?: number;
  selected?: boolean;
}

/** Teardrop map pin with an optional icon or label inside. */
export function MapPin({
  color = "brand",
  variant = "default",
  label,
  children,
  size = 40,
  selected,
  className = "",
  ...rest
}: MapPinProps) {
  const t = toneOf(color);

  if (variant === "label") {
    return (
      <span
        className={className}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "6px 10px",
          borderRadius: "var(--r-full)",
          background: t.solid,
          color: "#fff",
          fontFamily: "var(--font-ui-label)",
          fontWeight: 500,
          fontSize: 14,
          lineHeight: "20px",
          boxShadow: selected
            ? `0 0 0 4px ${t.bg}, var(--shadow-m)`
            : "var(--shadow-m)",
        }}
        {...rest}
      >
        {children}
        {label}
      </span>
    );
  }

  if (variant === "dot") {
    return (
      <span
        className={className}
        style={{
          display: "inline-block",
          width: 14,
          height: 14,
          borderRadius: "50%",
          background: t.solid,
          boxShadow: "0 0 0 3px #fff, var(--shadow-s)",
        }}
        {...rest}
      />
    );
  }

  return (
    <span
      className={className}
      style={{
        position: "relative",
        display: "inline-grid",
        placeItems: "center",
        width: size,
        height: size * 1.2,
        filter: "drop-shadow(0 4px 6px rgba(20,28,37,.18))",
      }}
      {...rest}
    >
      <svg
        width={size}
        height={size * 1.2}
        viewBox="0 0 40 48"
        style={{ position: "absolute", inset: 0 }}
      >
        <path d="M20 48s16-18.4 16-28A16 16 0 1 0 4 20c0 9.6 16 28 16 28Z" fill={t.solid} />
        <circle cx="20" cy="20" r="12" fill="#fff" />
      </svg>
      <span
        style={{
          position: "relative",
          marginTop: -size * 0.14,
          display: "grid",
          placeItems: "center",
          color: t.solid,
        }}
      >
        {children}
      </span>
    </span>
  );
}
